import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import { Button, Grid, TextField } from "@mui/material";
import RadioBtn from "components/Attendance/RadioBtn";
import BackButton from "components/shared/BackButton";
import DatePickerCM from "components/shared/DatePicker";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import TableCM from "components/shared/Table";
import GenarateHeadCell from "helper/generate-head-cell";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { attendanceSchema } from "validations";
import {
  ButtonContainer,
  StyledStack,
  StyledTitle,
} from "./editAttendace.style";
import {
  getAttendaceByIdRequest,
  updateAttendaceByIdRequest,
} from "api/requests";
import { convertNum } from "helper/convert-num";
import { DateObject } from "react-multi-date-picker";
import { persian } from "react-date-object/calendars/persian";
import { convertToUniqueArrayObject } from "helper/data-converter";

const headCells = GenarateHeadCell("teacher_user_attendance");
const students = [];

export default function TeacherEditAttendance() {
  const { loading, request, setLoading } = useHttp();

  // get class_id from url
  const { attendance_id } = useParams();

  // data picker stat
  const [date, setDate] = useState(null);

  const [page] = useState(1);

  // students data state
  const [attendanceUser, setAttendanceUser] = useState({ data: [], count: 0 });

  // class id state
  const [classId, setClassId] = useState(null);

  const navigate = useNavigate();
  const onDateChange = (value) => {
    setDate(value);
  };

  // handle change student status
  const onAttendanceChange = (value) => {
    students.push({
      ...value,
      student_id: `${value.student_id}`,
    });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(attendanceSchema),
  });

  // get class students list
  const getUsers = useCallback(async () => {
    const { data: res } = await request({
      url: getAttendaceByIdRequest,
      values: {
        attendance_id,
      },
      isMulty: true,
    });

    setLoading(false);
    if (res) {
      let transformedData = res.attendance_students.map((items) => ({
        id: items.student.id,
        fullName: `${items.student.first_name} ${items.student.last_name}`,
        level: items.student.level ? items.student.level : "ثبت نشده",
        national_code: items.student.national_code ?? "ثبت نشده",
        userAttendance: (
          <RadioBtn
            id={items?.student.id}
            isPresent={items?.is_present}
            edit
            onAttendanceChange={onAttendanceChange}
          />
        ),
      }));

      reset({ date: res.date.jdate });
      setAttendanceUser({ data: transformedData });
      setClassId(res.class_id);
      setDate(
        new DateObject({
          date: res.date.timestamp * 1000,
          calendar: persian,
        })
      );
    }
  }, [attendance_id, request, reset, setLoading]);

  // update class attendance
  const onSubmit = async () => {
    const transformedData = {
      date: date
        .format("YYYY-MM-DD")
        .split("-")
        .map((item) => convertNum(item))
        .join("-"),
      students: convertToUniqueArrayObject({
        array: students,
        index: "last",
        key: "student_id",
      }),
      attendance_id,
    };
    const res = await request({
      url: updateAttendaceByIdRequest,
      values: transformedData,
    });
    if (res) {
      Toast({ type: "success", title: "ویرایش حضور و غیاب" });
      reset({
        date: "",
      });
      navigate(`/teacher_classes/${classId}/attendance/`);
    }
  };
  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <DrawerCM title="ویرایش حضور و غیاب" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item xs={12}>
              <BackButton />
            </Grid>
          </Grid>
          <StyledStack>
            <StyledTitle>تاریخ حضور غیاب</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <DatePickerCM
                  onChange={onDateChange}
                  value={date}
                  render={(value, openCalendar) => {
                    return (
                      <TextField
                        fullWidth
                        onClick={openCalendar}
                        value={value ? value : ""}
                        label="انتخاب تاریخ"
                        variant="outlined"
                        id="date"
                        {...register("date")}
                        error={Boolean(errors.date)}
                        helperText={errors.date?.message}
                      />
                    );
                  }}
                />
              </Grid>
            </Grid>
          </StyledStack>
          <Grid item xs={12} my={2}>
            <TableCM
              title="لیست دانش آموزها"
              rows={attendanceUser.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          <ButtonContainer>
            <Button
              startIcon={<CheckIcon />}
              variant="contained"
              sx={{ mt: 1 }}
              onClick={handleSubmit(onSubmit)}
            >
              ذخیره
            </Button>
          </ButtonContainer>
        </Fragment>
      )}
    </DrawerCM>
  );
}
